<template>
  <div v-if="renderReady" ref="root">
    <label v-if="getTitle" class="label">
      {{ getTitle }}
      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{ tooltipContent }}</w-tooltip>
    </label>
    <div class="input w-datepicker" :class="{'state-error': model.$error, 'state-disabled': disabled && !borderless, active: datePickerVisible}">
      <i class="icon-prepend fa fa-calendar" v-if="showIcon && showIconOnResolution"></i>
      <input
        type="text"
        ref="input"
        :placeholder="datepicker.options.placeholder || placeholder"
        :value="this.reductView"
        readonly="readonly"
        autocomplete="off"
        @focus="toggleDatePicker()"
        :name="model.$form.testPath ? model.$path : undefined"
      />

      <button v-if="model.$model && model.$model.length > 0 && shouldHaveTimePicker" ref="timepicker" class="btn btn-append btn-primary" @click="showTimePicker">
        <i class="fa fa-clock-o"></i>
      </button>

      <div v-if="shouldHaveTimePicker && timePickerVisible" class="vdp-datepicker timepicker">
        <div class="vdp-datepicker__calendar">
          <header>
            <span class="day__month_btn up">Wybierz godzinę</span>
          </header>
          <div style="padding: 10px;">
            <div class="row">
              <div class="col col-6">
                <label>Godzina</label>
                <label for class="select">
                  <select :value="hours" @change="hoursChanged">
                    <option v-for="i in 24" :key="'hour' + i" :value="i - 1">{{ i < 10 ? 0 : '' }}{{ i - 1 }}</option>
                  </select>
                  <i></i>
                </label>
              </div>
              <div class="col col-6">
                <label>Minuta</label>
                <label for class="select">
                  <select :value="minutes" @change="minutesChanged">
                    <option v-for="i in 60" :key="'minute' + i" :value="i - 1">{{ i < 10 ? 0 : '' }}{{ i - 1 }}</option>
                  </select>
                  <i></i>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <datepicker
        v-bind:class="{'vdp-datepicker__left': leftSide, 'vdp-datepicker__top': topSide}"
        v-if="datePickerVisible"
        ref="datePicker"
        :disabled="disabled"
        :minimum-view="minView"
        :maximum-view="maxView"
        :placeholder="datepicker.options.placeholder || placeholder"
        :language="datepicker.language"
        :format="datepicker.options.format"
        :value="model.$model"
        :clear-button="datepicker.options.clearButton"
        :disabledDates="getDisabledDates"
        :full-month-name="true"
        :open-date="openDate"
        @input="dateChanged"
        @focus="onFocus($event)"
        @blur="pickerBlur($event)"
        @closed="pickerBlur($event)"
      ></datepicker>
    </div>
    <w-error :model="model" @focus="datePickerVisible ? $refs.input.focus() : $refs.datePicker.focus()"></w-error>
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';
import WTooltip from './tooltip.vue';
import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js';
import pl from 'vuejs-datepicker/dist/locale/translations/pl';
import {schemaMethods} from '@witkac/jschema';

// import {pl} from 'vuejs-datepicker/dist/locale';
export default {
  name: 'w-datepicker',
  components: {WError, Datepicker, WTooltip},
  props: {
    placeholder: String,
    dateOptions: {
      type: Object,
      default: () => ({})
    },
    disabledDates: Object,
    position: {
      // bottom-left; bottom-right; top-left; top-right
      type: String,
      default: 'bottom-right'
    },
    reducedView: {
      // dd-mm-yyyy; mm-yyyy; dd-mm; dd; mm; yyyy
      type: String,
      default: 'dd-mm-yyyy'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  mixins: [modelMixin],
  data() {
    const dateOpts = {
      placeholder: this.placeholder || '',
      format: 'dd.MM.yyyy'
    };
    return {
      showIconOnResolution: false,
      datePickerVisible: false,
      timePickerVisible: false,
      datepicker: {
        language: pl,
        value: '',
        options: {...dateOpts, ...this.dateOptions}
      }
    };
  },

  methods: {
    minutesChanged($event) {
      this.model.$model = schemaMethods.dateSet(this.model.$model, 'm', $event.target.value);
    },
    hoursChanged($event) {
      this.model.$model = schemaMethods.dateSet(this.model.$model, 'h', $event.target.value);
    },
    onBodyClick($event) {
      if (!this.datePickerVisible && !this.timePickerVisible) {
        return;
      }
      if ($event.target === this.$refs.input || $event.target === this.$refs.timepicker || $event.target.parentElement === this.$refs.timepicker) {
        return;
      }

      let hasClass = false;
      let parent = $event.target.parentElement;

      while (parent) {
        for (let i = 0; i < parent.classList.length; i++) {
          if (parent.classList[i] === 'vdp-datepicker') {
            hasClass = true;
            break;
          }
        }

        parent = parent.parentElement;
      }

      if (hasClass) {
        return;
      }

      if (this.datePickerVisible) {
        this.hideDatePicker();
      }

      if (this.timePickerVisible) {
        this.timePickerVisible = false;
      }
    },
    showTimePicker($event) {
      $event.preventDefault();
      this.datePickerVisible = false;
      this.timePickerVisible = true;
    },
    toggleDatePicker() {
      if (this.datePickerVisible) {
        this.hideDatePicker();
      } else {
        if (!this.model.$schema.readOnly) {
          this.showDatePicker();
        }
      }
    },
    showDatePicker() {
      this.datePickerVisible = true;
      this.timePickerVisible = false;
      const self = this;
      // pokae się dopiero za chwilę
      this.$nextTick(() => {
        self.$refs.datePicker.$el.children[0].children[0].focus();
        self.$refs.datePicker.showCalendar();
        self.model.$hasFocus = true;
      });
    },
    hideDatePicker() {
      const self = this;
      this.$set(this, 'datePickerVisible', false);
      this.$nextTick(() => {
        self.model.$hasFocus = false;
        this.$refs.input.blur();
        // self.$refs.datePicker.showCalendar();
      });
    },

    pickerBlur($event) {
      this.hideDatePicker();
      // onBlur($event);
    },

    dateChanged(newValue) {
      const tnewvalue = newValue.getTime();
      if (this.localValue === undefined || tnewvalue !== this.localValue) {
        // this.resize(newValue);
        // console.log('dtpicker', newValue);
        this.localValue = tnewvalue;
        const pad = num => {
          if (num >= 10) {
            return num;
          } else {
            return '0' + num;
          }
          // const norm = Math.floor(Math.abs(num));
          // return (norm < 10 ? '0' : '') + norm;
        };
        // const stringValue = newValue.getFullYear() + '-' + pad(newValue.getMonth() + 1) + '-' + pad(newValue.getDate());
        const stringValue = schemaMethods.fdatetime(newValue, 'dd.MM.yyyy');
        // console.log('dateChanged', newValue, tnewvalue, this.localValue, stringValue);
        // const stringValue = pad(newValue.getDate()) + '.' + pad(newValue.getMonth() + 1) + '.' + newValue.getFullYear();
        // this.localValue = stringValue;
        this.$emit('input', stringValue);
        this.fieldChanged();

        if (!this.$options.vmodel) {
          if (this.$options.lazy) {
            // if (this.lazy) {
            // return;
          }
          if (this.shouldHaveTimePicker) {
            this.model.$model = schemaMethods.fdatetime(newValue);
          } else {
            this.model.$model = schemaMethods.fdate(newValue);
          }

          this.model.$hasFocus = false;
        }
      }

      if (this.shouldHaveTimePicker) {
        this.timePickerVisible = true;
      }
    },
    setShowIconOnResolution() {
      if (this.$refs.root) {
        const reck = this.$refs.root.getBoundingClientRect();
        this.showIconOnResolution = reck && reck.width > 150;
      }
    }
    /*

    clickOutside() {
      this.hideDatePicker();

      document.removeEventListener('click', this.clickOutside, true);
    }
    */
  },
  computed: {
    minutes() {
      if (!this.model.$model) {
        return 0;
      }

      return schemaMethods.datePart(this.model.$model, 'm');
    },
    hours() {
      if (!this.model.$model) {
        return 0;
      }

      return schemaMethods.datePart(this.model.$model, 'h');
    },
    shouldHaveTimePicker() {
      return this.model.$schema.type === 'string' && this.model.$schema.format === 'date-time';
    },
    reductView() {
      const val = this.model.$model;
      const valDate = new Date(val);
      const day = valDate.getDay();
      const month = valDate.getMonth();
      let monthName = '';
      const year = valDate.getFullYear();
      if (!val) {
        return this.model.$value;
      }

      if (this.shouldHaveTimePicker) {
        return this.model.$model;
      }

      switch (this.reducedView) {
        case 'dd':
          return day;
        case 'mm':
          return month;
        case 'yyyy':
          return year;
        case 'mm-yyyy':
          switch (month) {
            case 0:
              monthName = 'styczeń';
              break;
            case 1:
              monthName = 'luty';
              break;
            case 2:
              monthName = 'marzec';
              break;
            case 3:
              monthName = 'kwiecień';
              break;
            case 4:
              monthName = 'maj';
              break;
            case 5:
              monthName = 'czerwiec';
              break;
            case 6:
              monthName = 'lipiec';
              break;
            case 7:
              monthName = 'sierpnień';
              break;
            case 8:
              monthName = 'wrzesień';
              break;
            case 9:
              monthName = 'październik';
              break;
            case 10:
              monthName = 'listopad';
              break;
            case 11:
              monthName = 'grudzień';
              break;
          }
          return monthName + ' ' + year;
        case 'dd-mm':
          switch (month) {
            case 0:
              monthName = 'stycznia';
              break;
            case 1:
              monthName = 'lutego';
              break;
            case 2:
              monthName = 'marca';
              break;
            case 3:
              monthName = 'kwietnia';
              break;
            case 4:
              monthName = 'maja';
              break;
            case 5:
              monthName = 'czerwca';
              break;
            case 6:
              monthName = 'lipca';
              break;
            case 7:
              monthName = 'sierpnia';
              break;
            case 8:
              monthName = 'września';
              break;
            case 9:
              monthName = 'października';
              break;
            case 10:
              monthName = 'listopada';
              break;
            case 11:
              monthName = 'grudnia';
              break;
          }
          return day + ' ' + monthName;
        case 'dd-mm-yyyy':
        default:
          return this.model.$value;
      }
    },
    minView() {
      switch (this.reducedView) {
        case 'yyyy':
          return 'year';
        case 'mm':
        case 'mm-yyyy':
          return 'month';
        case 'dd':
        case 'dd-mm':
        case 'dd-mm-yyyy':
        default:
          return 'day';
      }
    },
    maxView() {
      switch (this.reducedView) {
        case 'dd':
          return 'day';
        case 'dd-mm':
        case 'mm':
          return 'month';
        case 'dd-mm-yyyy':
        case 'mm-yyyy':
        case 'yyyy':
        default:
          return 'year';
      }
    },
    leftSide() {
      return this.position.includes('left');
    },
    topSide() {
      return this.position.includes('top');
    },
    getDisabledDates() {
      let disabledDates = this.disabledDates;
      const $schema = this.model.$schema;
      // const minimumDate = this.model.$schema.minimum;
      // const maximumDate = this.model.$schema.maximum;
      if (disabledDates === undefined) {
        disabledDates = {};
      }
      if ($schema.exclusiveMinimum) {
        disabledDates.to = schemaMethods.dateParse($schema.exclusiveMinimum + 'T23:59:59');
      }
      if ($schema.minimum) {
        // disabledDates.to = new Date(minimumDate);
        disabledDates.to = schemaMethods.dateParse($schema.minimum + 'T00:00:00');
      }
      if ($schema.exclusiveMaximum) {
        disabledDates.from = schemaMethods.dateParse($schema.exclusiveMaximum + 'T00:00:00');
        // disabledDates.from = new Date(maximumDate);
      }
      if ($schema.maximum) {
        disabledDates.from = schemaMethods.dateParse($schema.maximum + 'T23:59:59');
        // disabledDates.from = new Date(maximumDate);
      }
      return disabledDates;
    },
    openDate: {
      get() {
        return this.model.$model ? new Date(this.model.$model) : this.getDisabledDates.to || new Date();
      }
    }
  },
  created() {
    window.addEventListener('resize', this.setShowIconOnResolution.bind(this));
    window.addEventListener('click', this.onBodyClick.bind(this));
  },
  mounted() {
    this.setShowIconOnResolution();
  },
  destroyed() {
    window.removeEventListener('resize', this.setShowIconOnResolution);
    window.removeEventListener('click', this.onBodyClick);
  },
  watch: {
    dateOptions(next, prev) {
      this.datepicker.options = {...this.datepicker.options, ...next};
    },
    placeholder(next, prev) {
      this.$set(this.datepicker.options, 'placeholder', next);
    }
  }
};
</script>

<style>
.timepicker .day__month_btn {
  width: 100%;
}
.w-datepicker.active {
  position: relative;
}
.w-datepicker.active > input {
  position: absolute;
  z-index: 1;
}
.w-datepicker > .icon-prepend {
  z-index: 2;
}
.smart-form .input .icon-prepend .vdp-datepicker input {
  padding-left: 37px !important;
}

.vdp-datepicker__left > div:not(:first-child) {
  right: 0%;
}
.vdp-datepicker__top > div:not(:first-child) {
  bottom: 100%;
}
.vdp-datepicker__calendar .cell.selected {
  color: #fff;
  background-color: #a90329;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  background-color: #428bca;
  color: white;
}
.vdp-datepicker__calendar header {
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
}
.vdp-datepicker__calendar .cell {
  border: 1px solid transparent !important;
}
.vdp-datepicker__calendar .cell.selected::before,
.vdp-datepicker__calendar .cell.selected::after {
  content: none;
}
.btn-append {
  right: 0;
  position: absolute;
  top: 0;
}
.btn-append:active {
  right: 0 !important;
  position: absolute !important;
  top: 0 !important;
  left: initial !important;
}
</style>
